import { useCallback, useState } from 'react';
import { apiService } from '../Api/APIService';
import { fetchUser } from '../store/User';
import { IdentityProvider } from '../Api/Auth/identityProvider';

export const useApiToken = (provider: IdentityProvider) => {
  const [token, setToken] = useState<string | null>(null);

  const installToken = useCallback(
    (accessToken: string) => {
      setToken(accessToken);
      apiService.setToken(accessToken, provider);
      fetchUser();
    },
    [provider]
  );

  const dropToken = useCallback(() => {
    setToken(null);
    apiService.clearToken();
  }, []);

  return { token, installToken, dropToken };
};
